import type { Dispatch, SetStateAction } from 'react';

import { Status } from '@pega/cosmos-react-core';
import type { OmitStrict } from '@pega/cosmos-react-core';
import type { SearchResultProps, SearchResultsProps } from '@pega/cosmos-react-work';

const description =
  'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec semper, arcu eu sodales accumsan, ante purus fermentum dolor, ac convallis urna nisl eget lectus. Vivamus ut neque et turpis posuere pharetra imperdiet id augue. Nullam porta venenatis pharetra. Donec hendrerit, dolor eleifend vulputate tristique, dui dolor consequat ante, a vestibulum mi neque in purus.';

type ResultMeta = OmitStrict<SearchResultProps, 'link' | 'meta'> & {
  meta?: (NonNullable<SearchResultProps['meta']>[number] | Date)[];
};

const getResultLink = (
  result: ResultMeta,
  setPreview: Dispatch<SetStateAction<ResultMeta | undefined>>,
  setPreviewTabId: Dispatch<SetStateAction<string | undefined>>
) => {
  return {
    href: `projects/${result.id}`,
    previewable: true,
    onPreview: () => {
      setPreview(result);
      setPreviewTabId(`summary-${result.id}`);
    }
  };
};

export const searchResults = [
  {
    id: 'PROJ-300',
    title: 'The Art of Building Beautiful Demos',
    description,
    meta: ['Completed', 'Low priority', new Date('01/01/21')]
  },
  {
    id: 'PROJ-123',
    title: 'Be Single Minded',
    description,
    meta: ['Blocked', 'Medium priority', new Date('12/31/20')]
  },
  {
    id: 'PROJ-456',
    title: 'Differentiate Yourself and Attract More Attention Sales and Profits',
    description,
    meta: ['Pending', 'High priority', new Date('12/01/20')]
  },
  {
    id: 'PROJ-789',
    title: 'Importance of the Custom Test',
    description,
    meta: ['Completed', 'Medium priority', new Date('01/01/21 08:00:00')]
  },
  {
    id: 'PROJ-100',
    title: 'Improve Your Business Cards and Enhance Your Sales',
    description,
    meta: ['Ready', 'High priority', new Date('12/31/20')]
  },
  {
    id: 'PROJ-200',
    title: 'How to Write Better Advertising',
    description,
    meta: ['Ready', 'Low priority', new Date('12/25/20')]
  }
];

export const getInitialResults = (
  setPreview: Dispatch<SetStateAction<ResultMeta | undefined>>,
  setPreviewTabId: Dispatch<SetStateAction<string | undefined>>
): (ResultMeta & { link: NonNullable<SearchResultProps['link']> })[] => {
  return searchResults.map(result => {
    return {
      ...result,
      link: getResultLink(result, setPreview, setPreviewTabId)
    };
  });
};

export const initialFilters: SearchResultsProps['filters'] = [
  {
    type: 'select',
    name: 'Status',
    items: [
      {
        id: 'blocked',
        label: <Status variant='urgent'>Blocked</Status>,
        checked: false,
        name: 'Blocked'
      },
      {
        id: 'pending',
        label: <Status variant='pending'>Pending</Status>,
        checked: false,
        name: 'Pending'
      },
      { id: 'ready', label: <Status variant='info'>Ready</Status>, checked: false, name: 'Ready' },
      {
        id: 'completed',
        label: <Status variant='success'>Completed</Status>,
        checked: false,
        name: 'Completed'
      }
    ]
  },
  {
    type: 'select',
    selectType: 'single-select',
    name: 'Last updated',
    items: [
      { id: 'today', label: 'Today', checked: false, name: 'Today' },
      { id: 'yesterday', label: 'Yesterday', checked: false, name: 'Yesterday' },
      { id: '7-days', label: 'Last 7 days', checked: false, name: 'Last 7 days' },
      { id: '30-days', label: 'Last 30 days', checked: false, name: 'Last 30 days' }
    ]
  }
];
